import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Onboarding from './pages/Onboarding';
import StageMap from './pages/StageMap';
import LevelDetail from './pages/LevelDetail';
import KnowledgeCards from './pages/KnowledgeCards';
import Quiz from './pages/Quiz';
import Result from './pages/Result';
import Review from './pages/Review';
import Challenge from './pages/Challenge';
import StageChallenge from './pages/StageChallenge';
import StageComplete from './pages/StageComplete';
import Dashboard from './pages/Dashboard';
import Family from './pages/Family';
import Achievements from './pages/Achievements';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/onboarding" element={<Onboarding />} />
          <Route path="/map" element={<StageMap />} />
          <Route path="/level/:levelId" element={<LevelDetail />} />
          <Route path="/cards/:levelId" element={<KnowledgeCards />} />
          <Route path="/quiz/:levelId" element={<Quiz />} />
          <Route path="/result" element={<Result />} />
          <Route path="/stage-complete" element={<StageComplete />} />
          <Route path="/review" element={<Review />} />
          <Route path="/challenge" element={<Challenge />} />
          <Route path="/stage-challenge/:stageId" element={<StageChallenge />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/family" element={<Family />} />
          <Route path="/achievements" element={<Achievements />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;